var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageRecipients = function SvgMessageRecipients(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "message_recipients_svg2__a",
    x1: 31,
    x2: 209.6,
    y1: 195.8,
    y2: 79.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#message_recipients_svg2__a",
    id: "message_recipients_svg2__b",
    x1: 25.5,
    x2: 204.1,
    y1: 187.3,
    y2: 71
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#message_recipients_svg2__a",
    id: "message_recipients_svg2__c",
    x1: -11.7,
    x2: 166.9,
    y1: 130.2,
    y2: 13.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#message_recipients_svg2__a",
    id: "message_recipients_svg2__d",
    x1: -23.7,
    x2: 154.9,
    y1: 111.8,
    y2: -4.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M116.4 138.1c8.8-5.5 14.6-15.2 14.6-26.3 0-17.1-13.9-31-31-31s-31 13.9-31 31 5.8 20.8 14.6 26.3c-16.5 6.5-28.2 22.6-28.2 41.4v16.3c0 2.2 1.7 3.9 3.9 3.9h81.3c2.2 0 3.9-1.7 3.9-3.9v-16.3c0-18.8-11.7-34.9-28.2-41.4Zm-39.6-26.3c0-12.8 10.4-23.2 23.2-23.2s23.2 10.4 23.2 23.2S112.8 135 100 135s-23.2-10.4-23.2-23.2m59.9 80.1H63.3v-12.4c0-20.3 16.4-36.7 36.7-36.7s36.7 16.4 36.7 36.7z",
    style: {
      fill: "url(#message_recipients_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.3 109.5c-5.2-9.3-13.3-15.9-22.4-19.6 8.8-5.5 14.6-15.2 14.6-26.3 0-17.1-13.9-31-31-31s-31 13.9-31 31c0 11.1 5.8 20.8 14.6 26.3-1.9.7-3.7 1.6-5.5 2.6-1.9 1.1-2.5 3.4-1.5 5.3 1.1 1.9 3.4 2.6 5.3 1.5 5.5-3.1 11.7-4.7 18-4.7 20.3 0 36.8 16.4 36.8 36.7v12.4h-49.4c-2.2 0-3.9 1.7-3.9 3.9s1.7 3.9 3.9 3.9h53.3c2.2 0 3.9-1.7 3.9-3.9v-16.3c0-7.7-2-15.2-5.7-21.9Zm-62-45.9c0-12.8 10.4-23.2 23.2-23.2s23.2 10.4 23.2 23.2c0 12.7-10.3 23.1-23 23.2h-.4c-12.7 0-23-10.4-23-23.2",
    style: {
      strokeWidth: 0,
      fill: "url(#message_recipients_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1 147.6c0-2.2-1.7-3.9-3.9-3.9H7.8v-12.4c0-6.3 1.6-12.5 4.7-18 6.7-11.9 19.1-18.6 31.8-18.7h.3c6.1 0 12.2 1.5 17.9 4.7 1.9 1.1 4.3.4 5.3-1.5 1.1-1.9.4-4.3-1.5-5.3-1.8-1-3.6-1.9-5.5-2.6 8.8-5.5 14.6-15.2 14.6-26.3 0-17.1-13.9-31-31-31s-31 13.9-31 31c0 11.1 5.8 20.8 14.6 26.3-16.3 6.6-28 22.7-28 41.5v16.3c0 2.2 1.7 3.9 3.9 3.9h53.3c2.2 0 3.9-1.7 3.9-3.9Zm-39.7-84c0-12.8 10.4-23.2 23.2-23.2s23.2 10.4 23.2 23.2-10.4 23.2-23.2 23.2-23.2-10.4-23.2-23.2",
    style: {
      strokeWidth: 0,
      fill: "url(#message_recipients_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 62.3c17.1 0 31-13.9 31-31s-13.9-31-31-31-31 13.9-31 31 13.9 31 31 31m0-54.2c12.8 0 23.2 10.4 23.2 23.2S112.8 54.5 100 54.5 76.8 44.1 76.8 31.3 87.2 8.1 100 8.1",
    style: {
      strokeWidth: 0,
      fill: "url(#message_recipients_svg2__d)"
    }
  }));
};
export default SvgMessageRecipients;